import {
  PricingScheduleActivationCreate,
  PricingScheduleActivationEdit,
  PricingScheduleActivationList,
} from './PricingScheduleActivations'

export default {
  list: PricingScheduleActivationList,
  create: PricingScheduleActivationCreate,
  edit: PricingScheduleActivationEdit,
}
